// App.tsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import LoginScreen from './screens/LoginScreen';
import SignUpScreen from './components/SignUpScreen';
import ForgotPasswordScreen from './components/ForgotPasswordScreen';
import MyTabs from './components/MyTabs';
import VoyageurInsert from './components/VoyageurInsert';
import VoyageurUpdate from './components/VoyageurUpdate';
import AdresseFacturation from './components/AdresseFacturation';
import ProtectedRoute from './components/ProtectedRoute';
import { SnackbarProvider } from './components/SnackbarProvider';

import FormInde from './formulaires/FormInde';
import FormAngola from './formulaires/FormAngola';
import FormArabieSaoudite from './formulaires/FormArabieSaoudite';
import FormAustralie from './formulaires/FormAustralie';
import FormBahrein from './formulaires/FormBahrein';
import FormBenin from './formulaires/FormBenin';
import FormCambodge from './formulaires/FormCambodge';
import FormCameroun from './formulaires/FormCameroun';
import FormCanada from './formulaires/FormCanada';
import FormCapVert from './formulaires/FormCapVert';
import FormCoreeDuSud from './formulaires/FormCoreeDuSud';
import FormCoteIvoire from './formulaires/FormCoteIvoire';
import FormDjibouti from './formulaires/FormDjibouti';
import FormDubai from './formulaires/FormDubai';
import FormEgypte from './formulaires/FormEgypte';
import FormEthiopie from './formulaires/FormEthiopie';
import FormGuinee from './formulaires/FormGuinee';
import FormIndonesie from './formulaires/FormIndonesie';
import FormJordanie from './formulaires/FormJordanie';
import FormKenya from './formulaires/FormKenya';
import FormKoweit from './formulaires/FormKoweit';
import FormLaos from './formulaires/FormLaos';
import FormMadagascar from './formulaires/FormMadagascar';
import FormMyanmar from './formulaires/FormMyanmar';
import FormNouvelleZelande from './formulaires/FormNouvelleZelande';
import FormOman from './formulaires/FormOman';
import FormOuganda from './formulaires/FormOuganda';
import FormPapouasieNG from './formulaires/FormPapouasieNG';
import FormSeychelles from './formulaires/FormSeychelles';
import FormSriLanka from './formulaires/FormSriLanka';
import FormTanzanie from './formulaires/FormTanzanie';
import FormTogo from './formulaires/FormTogo';
import FormTurquie from './formulaires/FormTurquie';
import FormUSA from './formulaires/FormUSA';
import FormVietnam from './formulaires/FormVietnam';

import ClassiqueFormArabieSaoudite from './formulaires/ClassiqueFormArabieSaoudite'; 
import ClassiqueFormBangladesh from './formulaires/ClassiqueFormBangladesh';
import ClassiqueFormCentrafrique from './formulaires/ClassiqueFormCentrafrique';
import ClassiqueFormCongoBrazzaville from './formulaires/ClassiqueFormCongoBrazzaville';
import ClassiqueFormCongoKinshasa from './formulaires/ClassiqueFormCongoKinshasa';
import ClassiqueFormCoreeDuSud from './formulaires/ClassiqueFormCoreeDuSud';
import ClassiqueFormGabon from './formulaires/ClassiqueFormGabon';
import ClassiqueFormGhana from './formulaires/ClassiqueFormGhana';
import ClassiqueFormLiban from './formulaires/ClassiqueFormLiban';
import ClassiqueFormLiberia from './formulaires/ClassiqueFormLiberia';
import ClassiqueFormNepal from './formulaires/ClassiqueFormNepal';
import ClassiqueFormSoudan from './formulaires/ClassiqueFormSoudan';
import ClassiqueFormChine from './formulaires/ClassiqueFormChine';
import ClassiqueFormEthiopie from './formulaires/ClassiqueFormEthiopie';
import ClassiqueFormGuineeBissau from './formulaires/ClassiqueFormGuineeBissau';
import ClassiqueFormGuineeEquatoriale from './formulaires/ClassiqueFormGuineeEquatoriale';
import ClassiqueFormMadagascar from './formulaires/ClassiqueFormMadagascar';
import ClassiqueFormNigeria from './formulaires/ClassiqueFormNigeria';
import FormChineECard from './formulaires/FormChineECard';
import FormIndeECard from './formulaires/FormIndeECard';
import FormMalaisieECard from './formulaires/FormMalaisieECard';
import FormSingapourECard from './formulaires/FormSingapourECard';
import FormNigeria from './formulaires/FormNigeria';
import FormUK from './formulaires/FormUK';
import PaiementSucces from './screens/PaiementSucces';
import PageIntrouvable from './components/PageIntrouvable';
import FormulairePublicScreen from './screens/FormulairePublicScreen';
import { Celebration, OnboardingProvider } from './onboarding';

// Wrapper pour la route directe vers /parametres
const ParameterScreenRoute: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    // Redirige vers la page précédente ou /retour si pas d'historique
    navigate('/retour', { replace: true });
  }, [navigate]);

  return null;
};

function App() {
  return (
    <SnackbarProvider>
    <Router>
      {/* À L'INTÉRIEUR du Router : le provider appelle useLocation pour suivre
          les connexions/déconnexions. Au-dessus, le hook lèverait au montage. */}
      <OnboardingProvider>
      <Routes>

      <Route path="/formulaire_vietnam" element={<ProtectedRoute><FormVietnam /></ProtectedRoute>} />
      <Route path="/formulaire_usa" element={<ProtectedRoute><FormUSA /></ProtectedRoute>} />
      <Route path="/formulaire_turquie" element={<ProtectedRoute><FormTurquie /></ProtectedRoute>} />
      <Route path="/formulaire_togo" element={<ProtectedRoute><FormTogo /></ProtectedRoute>} />
      <Route path="/formulaire_tanzanie" element={<ProtectedRoute><FormTanzanie /></ProtectedRoute>} />
      <Route path="/formulaire_sri_lanka" element={<ProtectedRoute><FormSriLanka /></ProtectedRoute>} />
      <Route path="/formulaire_seychelles" element={<ProtectedRoute><FormSeychelles /></ProtectedRoute>} />
      <Route path="/formulaire_papouasie_ng" element={<ProtectedRoute><FormPapouasieNG /></ProtectedRoute>} />
      <Route path="/formulaire_ouganda" element={<ProtectedRoute><FormOuganda /></ProtectedRoute>} />
      <Route path="/formulaire_oman" element={<ProtectedRoute><FormOman /></ProtectedRoute>} />
      <Route path="/formulaire_nouvelle_zelande" element={<ProtectedRoute><FormNouvelleZelande /></ProtectedRoute>} />
      <Route path="/formulaire_myanmar" element={<ProtectedRoute><FormMyanmar /></ProtectedRoute>} />
      <Route path="/formulaire_madagascar" element={<ProtectedRoute><FormMadagascar /></ProtectedRoute>} />
      <Route path="/formulaire_laos" element={<ProtectedRoute><FormLaos /></ProtectedRoute>} />
      <Route path="/formulaire_koweit" element={<ProtectedRoute><FormKoweit /></ProtectedRoute>} />
      <Route path="/formulaire_kenya" element={<ProtectedRoute><FormKenya /></ProtectedRoute>} />
      <Route path="/formulaire_jordanie" element={<ProtectedRoute><FormJordanie /></ProtectedRoute>} />
      <Route path="/formulaire_indonesie" element={<ProtectedRoute><FormIndonesie /></ProtectedRoute>} />
      <Route path="/formulaire_guinee" element={<ProtectedRoute><FormGuinee /></ProtectedRoute>} />
      <Route path="/formulaire_ethiopie" element={<ProtectedRoute><FormEthiopie /></ProtectedRoute>} />
      <Route path="/formulaire_egypte" element={<ProtectedRoute><FormEgypte /></ProtectedRoute>} />
      <Route path="/formulaire_dubai" element={<ProtectedRoute><FormDubai /></ProtectedRoute>} />
      <Route path="/formulaire_djibouti" element={<ProtectedRoute><FormDjibouti /></ProtectedRoute>} />
      <Route path="/formulaire_cote_d_ivoire" element={<ProtectedRoute><FormCoteIvoire /></ProtectedRoute>} />
      <Route path="/formulaire_coree_du_sud" element={<ProtectedRoute><FormCoreeDuSud /></ProtectedRoute>} />
        <Route path="/formulaire_cap_vert" element={<ProtectedRoute><FormCapVert /></ProtectedRoute>} />
        <Route path="/formulaire_canada" element={<ProtectedRoute><FormCanada /></ProtectedRoute>} />
        <Route path="/formulaire_inde" element={<ProtectedRoute><FormInde /></ProtectedRoute>} />
        <Route path="/formulaire_angola" element={<ProtectedRoute><FormAngola /></ProtectedRoute>} />
        <Route path="/formulaire_arabie_saoudite" element={<ProtectedRoute><FormArabieSaoudite /></ProtectedRoute>} />
        <Route path="/formulaire_australie" element={<ProtectedRoute><FormAustralie /></ProtectedRoute>} />
        <Route path="/formulaire_bahrein" element={<ProtectedRoute><FormBahrein /></ProtectedRoute>} />
        <Route path="/formulaire_benin" element={<ProtectedRoute><FormBenin /></ProtectedRoute>} />
        <Route path="/formulaire_cambodge" element={<ProtectedRoute><FormCambodge /></ProtectedRoute>} />
        <Route path="/formulaire_cameroun" element={<ProtectedRoute><FormCameroun /></ProtectedRoute>} />

        <Route path="/classique_formulaire_arabie_saoudite" element={<ProtectedRoute><ClassiqueFormArabieSaoudite /></ProtectedRoute>} />
        <Route path="/classique_formulaire_bangladesh" element={<ProtectedRoute><ClassiqueFormBangladesh /></ProtectedRoute>} />
        <Route path="/classique_formulaire_centrafrique" element={<ProtectedRoute><ClassiqueFormCentrafrique /></ProtectedRoute>} />
        <Route path="/classique_formulaire_congo_brazzaville" element={<ProtectedRoute><ClassiqueFormCongoBrazzaville /></ProtectedRoute>} />
        <Route path="/classique_formulaire_congo_kinshasa" element={<ProtectedRoute><ClassiqueFormCongoKinshasa /></ProtectedRoute>} />
        <Route path="/classique_formulaire_coree_du_sud" element={<ProtectedRoute><ClassiqueFormCoreeDuSud /></ProtectedRoute>} />
        <Route path="/classique_formulaire_gabon" element={<ProtectedRoute><ClassiqueFormGabon /></ProtectedRoute>} />
        <Route path="/classique_formulaire_ghana" element={<ProtectedRoute><ClassiqueFormGhana /></ProtectedRoute>} />
        <Route path="/classique_formulaire_liban" element={<ProtectedRoute><ClassiqueFormLiban /></ProtectedRoute>} />
        <Route path="/classique_formulaire_Liberia" element={<ProtectedRoute><ClassiqueFormLiberia /></ProtectedRoute>} />
        <Route path="/classique_formulaire_Nepal" element={<ProtectedRoute><ClassiqueFormNepal /></ProtectedRoute>} />
        <Route path="/classique_formulaire_Soudan" element={<ProtectedRoute><ClassiqueFormSoudan /></ProtectedRoute>} />
        <Route path="/classique_formulaire_Chine" element={<ProtectedRoute><ClassiqueFormChine /></ProtectedRoute>} />
        <Route path="/classique_formulaire_Ethiopie" element={<ProtectedRoute><ClassiqueFormEthiopie /></ProtectedRoute>} />
        <Route path="/classique_formulaire_guinee_bissau" element={<ProtectedRoute><ClassiqueFormGuineeBissau /></ProtectedRoute>} />
        <Route path="/classique_formulaire_guinee_equatoriale" element={<ProtectedRoute><ClassiqueFormGuineeEquatoriale /></ProtectedRoute>} />
        <Route path="/classique_formulaire_madagascar" element={<ProtectedRoute><ClassiqueFormMadagascar /></ProtectedRoute>} />
        <Route path="/classique_formulaire_nigeria" element={<ProtectedRoute><ClassiqueFormNigeria /></ProtectedRoute>} />
        <Route path="/formulaire_chine_ecard" element={<ProtectedRoute><FormChineECard /></ProtectedRoute>} />
        <Route path="/formulaire_inde_ecard" element={<ProtectedRoute><FormIndeECard /></ProtectedRoute>} />
        <Route path="/formulaire_malaisie_ecard" element={<ProtectedRoute><FormMalaisieECard /></ProtectedRoute>} />
        <Route path="/formulaire_singapour_ecard" element={<ProtectedRoute><FormSingapourECard /></ProtectedRoute>} />
        <Route path="/formulaire_nigeria" element={<ProtectedRoute><FormNigeria /></ProtectedRoute>} />
        <Route path="/formulaire_uk" element={<ProtectedRoute><FormUK /></ProtectedRoute>} />






        <Route path="/" element={<LoginScreen />} />
        <Route path="/login" element={<LoginScreen />} />
        <Route path="/signup" element={<SignUpScreen />} />
        <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
        <Route path="/formulaire-public/:jeton" element={<FormulairePublicScreen />} />
        <Route path="/retour" element={<ProtectedRoute><MyTabs /></ProtectedRoute>} />
        <Route path="/parametres" element={<ProtectedRoute><ParameterScreenRoute /></ProtectedRoute>} />
        <Route path="/formulaire_creation_voyageur" element={<ProtectedRoute><VoyageurInsert /></ProtectedRoute>} />
        <Route path="/voyageur_update/:id" element={<ProtectedRoute><VoyageurUpdate /></ProtectedRoute>} />
        <Route path="/paiement" element={<ProtectedRoute><AdresseFacturation /></ProtectedRoute>} />
        <Route path="/paiement-succes" element={<ProtectedRoute><PaiementSucces /></ProtectedRoute>} />

        {/* Route catch-all. Sans elle, les 20 destinations visées par VisasScreen
            mais jamais déclarées ici produisent une page entièrement blanche,
            sans message ni sortie. Doit rester la DERNIÈRE route.
            ATTENTION : ajouter un formulaire impose TROIS modifications — l'import,
            la <Route> ci-dessus, et src/onboarding/routesDeclarees.ts. En oublier une
            annonce au client que sa destination n'est pas disponible en ligne
            (c'est exactement ce qui est arrivé à FormAngola). */}
        <Route path="*" element={<PageIntrouvable />} />




      </Routes>
      {/* Hors de <Routes> : la célébration doit survivre à la navigation qui la
          déclenche (création de voyageur -> formulaire du pays). */}
      <Celebration />
      </OnboardingProvider>
    </Router>
    </SnackbarProvider>
  );
}

export default App;
